class node{
    constructor(data){
        this.data = data
        this.next = null
        this.pre = null
    }
}
class LinkedList{
    constructor(){
        this.head = null
        this.current = null
    }
    insert(data){
        let newNode = new node(data)
        if(this.head === null){
            console.log('head is null')
            this.head = newNode
            this.current = newNode
        }
        else if (this.current === this.head){
            console.log('we are in the head')
            let temp = this.head
            newNode.pre = temp
            newNode.next = temp.next
            this.head.next = newNode
            this.current = newNode
        }
        else{
            console.log('added to last item')
            let temp = this.head
            while(temp.next !== null){
                temp = temp.next
            }
            temp.next = newNode
            newNode.pre = temp
            this.current = newNode
        }
        
    }
    undoEdit = () => {
        const preData = this?.current?.pre
        console.log('undo')
        if(preData === this.head){
            console.log('this is the head')
            this.current = preData
            return preData.data
        }
        else if(preData !== this.head && preData !== null){
            console.log('this is not the head')
            this.current = preData
            return preData.data
        }
        else{
            console.log('pre is null')
            return null
        }
    }
    redoEdit = () => {
        const nextData = this?.current?.next
        console.log('redo')
        if(nextData){
            this.current = nextData
            return nextData.data
        }
        else{
            return null
        }
    }
    resetEdit = () => {
        const headData = this.head
        console.log('undo')
        console.log(storedData)
        if(headData){
            this.current = headData
            return headData.data
        }
        else{
            return null
        }
    }
}
const storedData = new LinkedList()

export default storedData